import * as THREE from "three";

export class Branch {
	origin: THREE.Vector3;
	orientation: THREE.Euler;
	length: number;
	radius: number;
	level: number;
	sectionCount: number;
	segmentCount: number;

	/**
	 * Generates a new branch
	 * @param origin The starting point of the branch
	 * @param orientation The starting orientation of the branch
	 * @param length The length of the branch
	 * @param radius The radius of the branch at its starting point
	 */
	constructor(
		origin: THREE.Vector3 = new THREE.Vector3(),
		orientation: THREE.Euler = new THREE.Euler(),
		length = 0,
		radius = 0,
		level = 0,
		sectionCount = 0,
		segmentCount = 0,
	) {
		this.origin = origin.clone();
		this.orientation = orientation.clone();
		this.length = length;
		this.radius = radius;
		this.level = level;
		this.sectionCount = sectionCount;
		this.segmentCount = segmentCount;
	}
}
